import { Box, List } from "@mantine/core";

interface IProps {
    item: {
        toolName: string | null;
        toolArguments: string | null;
    };
}

function ToolUse({ item }: IProps) {
    const args: Record<string, string> = JSON.parse(item.toolArguments ?? "{}");
    return (
        <Box>
            {item.toolName}
            <List>
                {Object.entries(args).map(([key, value]) => (
                    <List.Item key={key}>
                        {key}: {value}
                    </List.Item>
                ))}
            </List>
        </Box>
    );
}

export default ToolUse;
